import Controls from './components/Controls';
import EndModal from './components/EndModal';
import { FIBQuiz } from './components/FiBQuiz/FillInBlanksQuiz';
import { MatchPairsQuiz } from './components/MatchPairsQuiz/MatchPairs';
import { McqQuiz } from './components/McqQuiz/MultipleChoiceQuestionQuiz';
import QuizModal from './components/QuizModal';
import { usePlayer } from './Hooks/usePlayer';

interface Subtitle {
  start: number;
  end: number;
  text: string;
}

export interface Chapter {
  start: number;
  end: number;
  title: string;
}

export interface Config {
  language: string;
  quizzes: QuizType[];
  subtitles: Subtitle[];
  passing_percentage: number;
  display_result: string;
  chapters: Chapter[];
}

export type QuizType = MatchPairsQuiz | McqQuiz | FIBQuiz;
export type QuizData = QuizType[];
export type QuizContainer = {
  time: number;
  quizzes: QuizData;
  displayed: boolean;
}[];

const App = () => {
  const { handlers, state, refs } = usePlayer();
  const {
    handleFullscreen,
    mouseMoveHandler,
    onSeekMouseDownHandler,
    handlePlaybackRateChange,
    muteHandler,
    volumeSeekUpHandler,
    volumeChangeHandler,
    seekMouseUpHandler,
    seekHandler,
    endHandler,
    progressHandler,
    handleFastFoward,
    rewindHandler,
    playPauseHandler,
    handleSubtitleChange,
    isModalOpenToggle,
    handleCorrect,
    handleEndModalOpen,
    playHandler,
    handleQuizAttemptEvent,
  } = handlers;
  const {
    volume,
    played,
    playedSeconds,
    playbackRate,
    showSubtitles,
    videoSrc,
    quizData,
    isEndModalOpen,
    quizSuccess,
    quizScore,
    currentTime,
    duration,
    muted,
    config,
    playing,
    isModalOpen,
    correct,
  } = state;
  const { videoPlayerRef, controlRef } = refs;

  return (
    <div className="flex flex-col justify-center items-center h-screen w-screen">
      <div
        className="h-full relative overflow-hidden"
        style={{ width: 'fit-content' }}
        onMouseMove={mouseMoveHandler}
        onDoubleClick={playPauseHandler}
      >
        <video
          src={videoSrc}
          muted={muted} // TODO: For local development use the video import, src={video}
          className="w-full h-full object-contain"
          onTimeUpdate={progressHandler}
          onEnded={endHandler}
          ref={videoPlayerRef}
        />

        {showSubtitles && (
          <div className="absolute inset-x-0 bottom-16 z-20 flex flex-row w-full justify-center">
            <div className="rounded-lg bg-default-50 p-2 bg-opacity-90 text-lg">
              {config?.subtitles
                .filter((subtitle: any) => {
                  return subtitle.start <= currentTime && subtitle.end >= currentTime;
                })
                .map((subtitle: any) => subtitle.text)
                .join(' ')}
            </div>
          </div>
        )}

        <Controls
          controlRef={controlRef}
          onPlayPause={playPauseHandler}
          playing={playing}
          onRewind={rewindHandler}
          onForward={handleFastFoward}
          played={played}
          onSeek={seekHandler}
          onSeekMouseUp={seekMouseUpHandler}
          onVolumeChangeHandler={volumeChangeHandler}
          onVolumeSeekUp={volumeSeekUpHandler}
          volume={volume}
          muted={muted}
          onMute={muteHandler}
          duration={duration}
          currentTime={currentTime}
          onMouseSeekDown={onSeekMouseDownHandler}
          playBackRate={playbackRate}
          setPlayBackRate={handlePlaybackRateChange}
          showSubtitles={showSubtitles}
          toggleSubtitles={() => handleSubtitleChange(!showSubtitles)}
          chapters={config?.chapters || []}
          playedSeconds={playedSeconds}
          onToggleFullscreen={handleFullscreen} // Pass the fullscreen handler
        />
      </div>
      <div>
        {quizData && (
          <QuizModal
            isOpen={isModalOpen}
            onClose={() => {
              isModalOpenToggle(false);

              playHandler();
            }}
            quiz={quizData}
            time={playedSeconds}
            correctMap={correct}
            setCorrectMap={handleCorrect}
            handleQuizAttemptEvent={handleQuizAttemptEvent}
          />
        )}
        {isEndModalOpen && !isModalOpen && (
          <EndModal
            isOpen={isEndModalOpen}
            onClose={() => {
              handleEndModalOpen(false);

              playHandler();
            }}
            //@ts-ignore
            quizzesExist={config?.quizzes.length > 0}
            quizSuccess={quizSuccess}
            quizScore={quizScore}
          />
        )}
      </div>
    </div>
  );
};

export default App;
